/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DocumentUploadPreviewTranslationsOtherPhotographPoint2 } from './DocumentUploadPreviewTranslationsOtherPhotographPoint2';
import type { DocumentUploadPreviewTranslationsOtherPhotographPoint1 } from './DocumentUploadPreviewTranslationsOtherPhotographPoint1';

export interface DocumentUploadPreviewTranslationsOtherPhotograph {
    point_1: DocumentUploadPreviewTranslationsOtherPhotographPoint1;
    point_2: DocumentUploadPreviewTranslationsOtherPhotographPoint2;
}
